import {extend, useThree, useFrame} from '@react-three/fiber';
import {useRef} from 'react';
import {useProgress, Html} from '@react-three/drei'
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

extend({OrbitControls});

export function Loader() {
    const {progress} = useProgress()
    return <Html center>{progress} % loaded</Html>
}

export const CameraControls = () => {
    // Get a reference to the Three.js Camera, and the canvas html element.
    // We need these to setup the OrbitControls component.
    // https://threejs.org/docs/#examples/en/controls/OrbitControls
    const {
        camera,
        gl: {domElement},
    } = useThree();
    // Ref to the controls, so that we can update them on every frame using useFrame
    const controls = useRef();
    useFrame((state) => controls.current.update());
    return <orbitControls
        ref={controls}
        args={[camera, domElement]}
        enableZoom={true}
        // autoRotate
        // autoRotateSpeed={1}
    />;
};